import ReactDOM from 'react-dom'
import { ReactNode, RefObject, useEffect } from 'react'
import styled from 'styled-components'

const MenuWrapper = styled.div`
  position: absolute;
  border-radius: 8px;
  border: 1px solid ${p => p.theme.colors.divider};
  box-shadow: 0px 0px 20px 0px ${p => p.theme.colors.menu.boxShadow};
  background: ${p => p.theme.colors.background.primary};
  z-index: 9999;
`

interface MenuProps {
  anchorElement: RefObject<HTMLElement | null>
  children: ReactNode
  style?: React.CSSProperties
  className?: string
  scrollContainerId?: string
  ref?: React.Ref<HTMLDivElement>
}

export const Menu = ({ anchorElement, children, style, className, scrollContainerId, ref }: MenuProps) => {
  useEffect(() => {
    const scrollTarget = scrollContainerId ? document.getElementById(scrollContainerId) : null

    const originalBodyOverflow = document.body.style.overflow
    const originalTargetOverflow = scrollTarget?.style.overflow

    document.body.style.overflow = 'hidden'
    if (scrollTarget) {
      scrollTarget.style.overflow = 'hidden'
    }

    return () => {
      document.body.style.overflow = originalBodyOverflow
      if (scrollTarget && originalTargetOverflow !== undefined) {
        scrollTarget.style.overflow = originalTargetOverflow
      }
    }
  }, [scrollContainerId])

  const anchor = anchorElement.current
  if (!anchor) return null

  const rect = anchor.getBoundingClientRect()

  return ReactDOM.createPortal(
    <MenuWrapper
      ref={ref}
      style={{
        top: rect.bottom + window.scrollY + 4,
        left: rect.left + window.scrollX,
        minWidth: rect.width,
        ...style,
      }}
      className={className}
    >
      {children}
    </MenuWrapper>,
    document.body
  )
}
